import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Home, Bookmark, User, LayoutDashboard } from 'lucide-react';

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const path = location.pathname;

  const isFarmer = user?.role === 'farmer';

  // Every signed-in user gets the same seller-side bottom nav.
  // Admins can still jump back to the panel via the "Admin panel" entry on Profile.
  // "Create post" lives in the floating action button (CreatePostFAB), so it's
  // intentionally NOT part of this pill nav anymore.
  const navItems = [
    { icon: Home, label: 'Feed', path: '/', testId: 'nav-feed' },
    { icon: Bookmark, label: 'Saved', path: '/saved', testId: 'nav-saved' },
    ...(isFarmer ? [
      { icon: LayoutDashboard, label: 'Dash', path: '/farmer-dashboard', testId: 'nav-dashboard' },
    ] : []),
    { icon: User, label: 'Profile', path: '/profile', testId: 'nav-profile' },
  ];

  return (
    <div
      data-testid="bottom-nav"
      className="fixed bottom-3 left-1/2 -translate-x-1/2 w-[calc(100%-24px)] max-w-[420px] md:max-w-[520px] lg:max-w-[560px] bg-white/85 backdrop-blur-2xl border border-[#E4E8EF] rounded-full shadow-[0_16px_40px_-16px_rgba(11,22,32,0.18),0_2px_6px_-2px_rgba(11,22,32,0.06)] pb-[env(safe-area-inset-bottom)] px-2 py-1.5 flex justify-around items-center z-[9999]"
    >
      {navItems.map((item) => {
        const isActive = path === item.path;
        const Icon = item.icon;

        return (
          <button
            key={item.path}
            data-testid={item.testId}
            onClick={() => navigate(item.path)}
            className={`relative flex flex-col items-center gap-0.5 py-2 px-3 rounded-full transition-all duration-200 ${
              isActive
                ? 'text-[#0B4F3F]'
                : 'text-[#5B6675] hover:text-[#0B1620]'
            }`}
            aria-label={item.label}
          >
            <Icon className="w-[18px] h-[18px]" strokeWidth={isActive ? 2.4 : 1.6} />
            <span className={`text-[10px] tracking-wide ${isActive ? 'font-semibold' : 'font-medium'}`}>{item.label}</span>
            {isActive && (
              <span className="absolute -bottom-0.5 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-[#0B4F3F] shadow-[0_0_6px_rgba(11,79,63,0.6)]" />
            )}
          </button>
        );
      })}
    </div>
  );
}
